import * as t from "./types";
import * as actions from "./action";

export const decodeJwtAction = (
  payload: t.DecodeJwtRequestType
): t.DecodeJwtActionType => {
  return {
    type: actions.DECODE_JWT,
    payload,
  };
};

export const refreshJwtAction = (
  payload: t.RefreshJwtRequestType
): t.RefreshJwtActionType => {
  return {
    type: actions.REFRESH_JWT,
    payload,
  };
};
